module.exports = __webpack_public_path__ + "static/img/sequence-4.6dfd060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/sequence-4.jpg
// module id = tOyU
// module chunks = 0